import type { Observer } from 'rxjs';
import { Observable } from 'rxjs';
import { Socket } from 'phoenix';

import { log } from './logs';

function wsTopic<M>(
  socket: Socket,
  topic: string,
  params?: object,
  topicActions?: string[]
): Observable<M> {
  return new Observable((observer: Observer<M>) => {
    const phoenixChannel = socket.channel(topic, params);
    phoenixChannel.join();
    phoenixChannel.on('notify', message => {
      observer.next(message);
      log(topic, params, message);
    });

    topicActions?.forEach(action => {
      phoenixChannel.on(action, message => {
        const actionMessage = {
          data: [
            {
              action,
              message,
              type: topic
            }
          ]
        } as M;
        observer.next(actionMessage);
        log(topic, params, actionMessage);
      });
    });

    log(topic, params, { app_action: 'Join channel' });

    socket.onOpen(() => {
      log(topic, params, { app_action: 'WS Open' });
    });
    socket.onError(() => {
      log(topic, params, { app_action: 'WS Error' });
    });
    socket.onClose(() => {
      log(topic, params, { app_action: 'WS Close' });
    });

    return () => {
      phoenixChannel.leave();
      log(topic, params, { app_action: 'Leave channel' });
    };
  });
}

const standaloneWebsocket = <M>(url: string, topic: string, params?: { params: object }) => {
  const socket = new Socket(url, params);
  socket.connect();
  return new Observable((observer: Observer<M>) => {
    const phoenixChannel = socket.channel(topic, params);
    phoenixChannel.join();
    phoenixChannel.on('notify', message => {
      observer.next(message);
      log(topic, params, message);
    });

    log(topic, params, { app_action: 'Join channel' });

    socket.onOpen(() => {
      log(topic, params, { app_action: 'WS Open' });
    });
    socket.onError(() => {
      log(topic, params, { app_action: 'WS Error' });
    });
    socket.onClose(() => {
      log(topic, params, { app_action: 'WS Close' });
    });

    return () => {
      phoenixChannel.leave();
      socket.disconnect();
      log(topic, params, { app_action: 'Leave channel' });
    };
  });
};

export { wsTopic, standaloneWebsocket };
